import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";

const ADD_WORKING_HOURS_STYLES = {
  modalContent: {
    overflow: "hidden",
    borderRadius: "0px",
    border: "1px solid rgba(226, 232, 240, 1)",
    boxShadow: "0 24px 60px rgba(15, 23, 42, 0.16)",
  },
  modalDialog: {
    maxWidth: "760px",
  },
  modalHeader: {
    padding: "18px 22px",
    borderBottom: "1px solid #e2e8f0",
    background: "#ffffff",
  },
  headerContent: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
  },
  titleWrap: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
  },
  headerIcon: {
    width: "46px",
    height: "46px",
    borderRadius: "0px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f1f5f9",
    color: "#0f172a",
    fontSize: "20px",
    boxShadow: "none",
  },
  title: {
    fontSize: "22px",
    fontWeight: 600,
    color: "#0f172a",
    lineHeight: 1.1,
    margin: 0,
  },
  subtitle: {
    fontSize: "12px",
    color: "#64748b",
    marginTop: "4px",
  },
  datePill: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    marginTop: "10px",
    padding: "6px 12px",
    borderRadius: "0px",
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "#eff6ff",
    color: "#1d4ed8",
    fontSize: "12px",
    fontWeight: 600,
  },
  closeButton: {
    width: "38px",
    height: "38px",
    borderRadius: "0px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#64748b",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease",
    flexShrink: 0,
  },
  modalBody: {
    padding: "20px 22px",
    background: "#ffffff",
  },
  helperCard: {
    borderRadius: "0px",
    padding: "16px",
    background: "#ffffff",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    marginBottom: "16px",
  },
  helperTitle: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#0f172a",
    marginBottom: "8px",
  },
  helperText: {
    fontSize: "12px",
    lineHeight: 1.7,
    color: "#64748b",
    margin: 0,
  },
  inputCard: {
    borderRadius: "0px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    boxShadow: "0 4px 12px rgba(15, 23, 42, 0.03)",
    padding: "16px",
    height: "100%",
  },
  inputLabel: {
    fontSize: "11px",
    fontWeight: 600,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    marginBottom: "8px",
  },
  inputHint: {
    fontSize: "12px",
    color: "#64748b",
    marginBottom: "10px",
    lineHeight: 1.5,
  },
  inputShell: {
    borderRadius: "0px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    boxShadow: "inset 0 1px 2px rgba(15, 23, 42, 0.03)",
    minHeight: "44px",
  },
  summaryBar: {
    marginTop: "16px",
    padding: "12px 14px",
    borderRadius: "0px",
    background: "#f8fafc",
    border: "1px solid rgba(226, 232, 240, 1)",
    fontSize: "13px",
    color: "#334155",
    fontWeight: 600,
  },
  warningBar: {
    marginTop: "16px",
    padding: "12px 14px",
    borderRadius: "0px",
    background: "#fffbeb",
    border: "1px solid rgba(253, 230, 138, 1)",
    fontSize: "12px",
    lineHeight: 1.6,
    color: "#92400e",
    fontWeight: 600,
  },
  modalFooter: {
    padding: "16px 22px 20px 22px",
    borderTop: "1px solid rgba(226, 232, 240, 0.9)",
    background: "#ffffff",
  },
  footerActions: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    flexWrap: "wrap",
  },
  subtleButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "0px",
    border: "1px solid #cbd5e1",
    background: "#ffffff",
    color: "#334155",
    padding: "9px 18px",
    fontSize: "13px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  primaryButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "0px",
    border: "1px solid #2563eb",
    background: "#2563eb",
    color: "#ffffff",
    padding: "9px 18px",
    fontSize: "13px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(37, 99, 235, 0.2)",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
};

const AddWorkingHrs = (props) => {
  const { showHide, handleShowHide, handleSelect, selectedObj } = props;

  const [hour, setHour] = useState("");
  const [minutes, setMinutes] = useState("");

  useEffect(() => {
    if (selectedObj?.title) {
      const wrkHr = selectedObj.title.toString().split(".");
      setHour(wrkHr[0] ?? "");
      setMinutes(wrkHr[1] ?? "");
    } else {
      setHour("");
      setMinutes("");
    }
  }, [selectedObj]);

  const formatDate = (date) => {
    if (!date) return "";
    const parsedDate = date instanceof Date ? date : new Date(date);
    if (!isNaN(parsedDate.getTime())) {
      return parsedDate.toLocaleDateString("en-US", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    }
    return "Invalid Date";
  };

  const doSubmit = () => {
    // Treat empty minutes as 0 when composing the value to send
    const hrNum = hour === "" ? 0 : Number(hour);
    const minStr = minutes === "" ? "0" : minutes.toString();
    let wrkHr;

    if (hrNum === 24) {
      // Force minutes to 0 when hr is 24
      wrkHr = "24.0";
    } else if (minStr && minStr !== "0") {
      wrkHr = `${hrNum}.${minStr}`;
    } else {
      wrkHr = hrNum; // integer number when minutes is 0 or empty
    }

    handleSelect(wrkHr);
  };

  // Normalize to numbers for validation (empty string => 0)
  const hrNum = hour === "" ? 0 : Number(hour);
  const minNum = minutes === "" ? 0 : Number(minutes);

  const bothEmpty = hour === "" && minutes === "";
  const zeroZero = hrNum === 0 && minNum === 0;
  const outOfRange = hrNum < 0 || hrNum > 24 || minNum < 0 || minNum > 59;
  const twentyFourInvalid = hrNum === 24 && minNum !== 0;

  const isInvalid = bothEmpty || zeroZero || outOfRange || twentyFourInvalid;
  const summaryValue =
    hrNum === 24
      ? "24h 0m"
      : `${hour === "" ? 0 : hrNum}h ${minutes === "" ? 0 : minNum}m`;

  return (
    <Modal
      show={showHide}
      size="xl"
      dialogClassName="add-working-hours-modal-dialog"
      contentClassName="add-working-hours-modal-content"
    >
      <style>{`
        .add-working-hours-modal-dialog {
          max-width: ${ADD_WORKING_HOURS_STYLES.modalDialog.maxWidth};
        }
        .add-working-hours-modal-content,
        .add-working-hours-modal-dialog .modal-content {
          overflow: hidden !important;
          border: ${ADD_WORKING_HOURS_STYLES.modalContent.border} !important;
          box-shadow: ${ADD_WORKING_HOURS_STYLES.modalContent.boxShadow} !important;
          border-radius: 0px !important;
        }
        .add-working-hours-modal-content .form-control {
          border-radius: 0px !important;
        }
      `}</style>
      <Modal.Header style={ADD_WORKING_HOURS_STYLES.modalHeader}>
        <div style={ADD_WORKING_HOURS_STYLES.headerContent}>
          <Modal.Title as="div" style={ADD_WORKING_HOURS_STYLES.titleWrap}>
            <span style={ADD_WORKING_HOURS_STYLES.headerIcon}>
              <i className="fa fa-clock-o" aria-hidden="true"></i>
            </span>
            <div>
              <div style={ADD_WORKING_HOURS_STYLES.title}>
                Add/Edit Hours and Minutes
              </div>
              <div style={ADD_WORKING_HOURS_STYLES.subtitle}>
                Enter the working time for the selected day and save your update.
              </div>
              <div style={ADD_WORKING_HOURS_STYLES.datePill}>
                {formatDate(selectedObj?.start)}
              </div>
            </div>
          </Modal.Title>
          <button
            type="button"
            style={ADD_WORKING_HOURS_STYLES.closeButton}
            onClick={() => handleShowHide("")}
            aria-label="Close working hours popup"
          >
            <i className="fa fa-times" aria-hidden="true"></i>
          </button>
        </div>
      </Modal.Header>

      <Modal.Body style={ADD_WORKING_HOURS_STYLES.modalBody}>
        <div style={ADD_WORKING_HOURS_STYLES.helperCard}>
          <div style={ADD_WORKING_HOURS_STYLES.helperTitle}>Quick tip</div>
          <p style={ADD_WORKING_HOURS_STYLES.helperText}>
            Use hours and minutes for the selected day. If you enter `24` hours,
            minutes are locked to `0` automatically.
          </p>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div style={ADD_WORKING_HOURS_STYLES.inputCard}>
              <label htmlFor="hour" style={ADD_WORKING_HOURS_STYLES.inputLabel}>
                Enter Hour
              </label>
              <div style={ADD_WORKING_HOURS_STYLES.inputHint}>
                Allowed range is 0 to 24 hours.
              </div>
              <input
                type="number"
                id="hour"
                name="hour"
                className="form-control"
                style={ADD_WORKING_HOURS_STYLES.inputShell}
                placeholder="Enter Hour"
                value={hour}
                onChange={({ currentTarget }) => {
                  let val = currentTarget.value;
                  if (val === "") {
                    setHour("");
                    return;
                  }
                  const n = Number(val);
                  if (isNaN(n)) return;
                  if (n < 0) val = "0";
                  if (n > 24) val = "24";
                  setHour(val);
                  if (val === "24") {
                    setMinutes("0");
                  }
                }}
              />
            </div>
          </div>

          <div className="col-md-6">
            <div style={ADD_WORKING_HOURS_STYLES.inputCard}>
              <label
                htmlFor="minutes"
                style={ADD_WORKING_HOURS_STYLES.inputLabel}
              >
                Enter Minutes
              </label>
              <div style={ADD_WORKING_HOURS_STYLES.inputHint}>
                Allowed range is 0 to 59 minutes.
              </div>
              <input
                type="number"
                id="minutes"
                name="minutes"
                className="form-control"
                style={ADD_WORKING_HOURS_STYLES.inputShell}
                placeholder="Enter Minutes"
                value={hour === "24" ? "0" : minutes}
                disabled={hour === "24"}
                onChange={({ currentTarget }) => {
                  let val = currentTarget.value;
                  if (val === "") {
                    setMinutes("");
                    return;
                  }
                  const n = Number(val);
                  if (isNaN(n)) return;
                  if (n < 0) val = "0";
                  if (n > 59) val = "59";
                  setMinutes(val);
                }}
              />
            </div>
          </div>
        </div>

        <div style={ADD_WORKING_HOURS_STYLES.summaryBar}>
          Selected duration: {summaryValue}
        </div>
        {isInvalid && (
          <div style={ADD_WORKING_HOURS_STYLES.warningBar}>
            Enter a valid time greater than `0h 0m`. Minutes must stay between
            `0-59`, and `24` hours only works with `0` minutes.
          </div>
        )}
      </Modal.Body>

      <Modal.Footer style={ADD_WORKING_HOURS_STYLES.modalFooter}>
        <div style={ADD_WORKING_HOURS_STYLES.footerActions}>
          <button
            type="button"
            className="btn btn-sm"
            style={ADD_WORKING_HOURS_STYLES.subtleButton}
            onClick={() => handleShowHide("")}
          >
            <i className="fa fa-times" aria-hidden="true"></i> Cancel
          </button>
          <button
            type="button"
            className="btn btn-sm"
            style={ADD_WORKING_HOURS_STYLES.primaryButton}
            disabled={isInvalid}
            onClick={doSubmit}
          >
            <i className="fa fa-check" aria-hidden="true"></i> Save
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AddWorkingHrs;
